import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';

@Component({
  selector: 'app-info-quote-modal',
  templateUrl: './info-quote-modal.component.html',
  styleUrls: ['./info-quote-modal.component.css']
})
export class InfoQuoteModalComponent implements OnInit {

  title: string;
  json: string;

  constructor(public dialogRef: MatDialogRef<InfoQuoteModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InfoQuoteModalComponent) {
    this.title = data.title;
    this.json = data.json;
  }

  ngOnInit() {
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    this.dialogRef.close(false);
  }

}

/**
 * Class to represent confirm dialog model.
 *
 * It has been kept here to keep it as part of shared component.
 */
 export class InfoQuoteModalModel {

  constructor(public title: string, public json: string) {
  }
}
